import Vue from 'vue';
import * as types from './types';
// eslint-disable-next-line import/no-cycle
import axios from '@/lib/axios';
import { errCodeMap } from '@/lib/errors';

// 模块
// eslint-disable-next-line import/no-cycle
import goodCrowdManage from './goodCrowdManage/index';
// eslint-disable-next-line import/no-cycle
import goodListManage from './goodListManage/index';
import commonApi from '@/apis/common';

export default {
  namespaced: true,
  state: {
    isShowGoodList: true,
    isDialogSyncCrowd: false,
    qqCrowdList: [],
    productIds: [],
    qqCrowdStateList: [],
    QqCrowdInviteCode: '',
    mediaList: [], // 媒体列表
    activeMedia: {}, // 激活的媒体
    media_type: '',
    media_id: '',
  },
  mutations: {
    [types.SET_MEDIA_INFO](state, {
      mediaType,
      mediaId,
    }) {
      state.media_id = mediaId;
      state.media_type = mediaType;
    },
    [types.SET_IS_SHOW_GOOD_LIST](state, isShow) {
      state.isShowGoodList = isShow;
    },
    [types.SET_DIALOG_SYNC_CROWD](state, isDialogSyncCrowd) {
      state.isDialogSyncCrowd = isDialogSyncCrowd;
    },
    [types.SET_QQ_CROWD_LIST](state, qqCrowdList) {
      state.qqCrowdList = qqCrowdList;
    },
    // 设置选中的商品列
    [types.SET_CHECKED_PRODUCT_ID_LIST](state, productIds) {
      state.productIds = productIds;
    },
    // 设置查询后的QQ群橱窗关于商品上架状态
    [types.SET_QQ_CROWD_STATE_LIST](state, qqCrowdStateList) {
      state.qqCrowdStateList = qqCrowdStateList;
    },
    // Q群邀请码
    [types.SET_QQ_CROWD_INVITE_CODE](state, QqCrowdInviteCode) {
      state.QqCrowdInviteCode = QqCrowdInviteCode;
    },
    [types.SET_MEDIA_LIST](state, list) {
      state.mediaList = list;
    },
    [types.SET_ACTIVE_MEDIA](state, activeMedia) {
      state.activeMedia = activeMedia;
    },
  },
  actions: {
    // 获取QQ群邀请码
    async fetchQqCrowdCode({ commit, state, rootState }) {
      const { profile } = rootState.userCenter;
      const { media_id: mediaId } = state.activeMedia;

      if (!mediaId) {
        commit(types.SET_QQ_CROWD_INVITE_CODE, '');

        return;
      }

      const params = {
        method: 'post',
        body: {
          media_id: mediaId,
          media_type: 4, // 4 : qq
          user_id: profile.user_id,
          uid: profile.uid,
        },
      };
      const res = await axios
        .post('v1/content/invited/code/create', params)
        .catch(() => {
          this.$tip.error('邀请码生成失败');
        });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '邀请码生成失败');

        return;
      }

      commit(types.SET_QQ_CROWD_INVITE_CODE, res.data.code);
    },
    async fetchQqCrowdList({ commit, state, rootState }) {
      const { profile } = rootState.userCenter;
      const { media_id: mediaId } = state.activeMedia;

      if (!mediaId) {
        commit(types.SET_QQ_CROWD_LIST, []);

        return;
      }

      const params = {
        method: 'post',
        body: {
          uid: profile.uid,
          user_id: profile.user_id,
          media_type: 4, // 1-微视  2-k歌  4 qq
          media_id: mediaId, // 绑定的媒体橱窗 id
          content_type: 41, // 内容类型 qq群橱窗
          page: 1, // 页码
          count: 1000, // 每页数量
          state: 2, // 0所有状态 1审核中 2通过 3拒绝
        },
      };
      const res = await axios
        .post('v1/media/content_account/list', params)
        .catch(() => {
          Vue.prototype.$tip.error('QQ店铺群橱窗列表失败');
        });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || 'QQ店铺群橱窗列表失败');
        return;
      }

      const data = (res.data.content_list || []).map((item) => {
        if (item.ext_info && typeof item.ext_info === 'string') {
          item.ext_info = JSON.parse(item.ext_info);
        } else {
          item.ext_info = {};
        }

        return item;
      }).sort((a, b) => {
        const nameA = a.content_name.toUpperCase();
        const nameB = b.content_name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

      commit(types.SET_QQ_CROWD_LIST, data);
    },
    async fetchCrowdShopwindowState({ state, commit, dispatch, rootState }) {
      const { profile } = rootState.userCenter;
      // QQ店铺下的群橱窗列表
      await dispatch('fetchQqCrowdList');
      const { productIds, qqCrowdList } = state;
      const contentIdList = qqCrowdList.map(item => item.content_id);

      if (productIds.length === 0 || contentIdList.length === 0) {
        commit(types.SET_QQ_CROWD_STATE_LIST, []);
        commit(types.SET_DIALOG_SYNC_CROWD, true);
        return;
      }

      const params = {
        method: 'post',
        body: {
          uid: profile.uid,
          user_id: profile.user_id,
          media_type: 4, // 1-微视  2-k歌
          content_type: 41, // 1视频 2直播 3歌房
          content_id_list: contentIdList, // 直播场次id | 视频feedid
          product_id_list: productIds, // 绑定的 product_id列表
        },
      };
      console.log(params);
      const res = await axios.post('v1/media/product/check_binding_content', params).catch(() => {
        Vue.prototype.$tip.error('检测商品是否在群橱窗上架情况失败');
      });
      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '检测商品是否在群橱窗上架情况失败');

        return;
      }

      const isBindings = res.data.is_binding;
      const qqCrowdStateList = qqCrowdList.map((item, index) => ({
        ...item,
        isBindings: isBindings[index],
      })).sort((a, b) => {
        const nameA = a.content_name.toUpperCase();
        const nameB = b.content_name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

      commit(types.SET_QQ_CROWD_STATE_LIST, qqCrowdStateList);
      commit(types.SET_DIALOG_SYNC_CROWD, true);
    },

    // 获取QQ媒体橱窗列表
    async fetchMediaList({
      commit,
    }) {
      try {
        const reqData = {
          block_by_eshop: true, // true 只展示ESHOP可展示的用户橱窗；false 展示所有用户橱窗
          media_type: 'qq', // String, 指定筛选的媒体类型，如：kg、om、qq，默认不筛选，非必传字段
        };
        const res = await commonApi.getMediaList(reqData, false);
        const code = Number(res?.head?.code);
        if (code !== 0) {
          const errorMsg = `[${code}] 获取橱窗列表失败：${res?.head?.msg}`;
          Vue.prototype.$message.error(errorMsg);
          return false;
        };

        const mediaList = res?.media_infos || [];
        commit(types.SET_MEDIA_LIST, mediaList);
        commit(types.SET_ACTIVE_MEDIA, mediaList[0]); // 设置第一个为选中项

        return true;
      } catch (err) {
        const errorMsg = `[${err?.code}] 获取橱窗列表失败：${err?.message}`;
        Vue.prototype.$message.error(errorMsg);
      }

      return false;
    },
  },
  modules: {
    goodCrowdManage,
    goodListManage,
  },
};
